<template>
    <f7-page name="what-friends-see" class="modern-ui">
        <bc-navbar></bc-navbar>
        <div class="page-container">
            <f7-link @click="goBack()"
                class="mui-button accent-50"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.625 12.5L3.125 8L7.625 3.5M3.75 8H12.875" stroke="currentColor" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg> Back</f7-link>

            <h1 class="title">
                Referral History
            </h1>

            <p class="subtitle">You’re sharing your personal referral page - not just a link</p>
            <div class="info-card">
                <ul class="options">
                    <li>
                        <check-rounded-icon />A personal introduction to [sales name]
                    </li>
                    <li>
                        <check-rounded-icon />A personal intro from you
                    </li>
                    <li>
                        <check-rounded-icon />Easy ways for your friend to start shopping
                    </li>
                    <li>
                        <check-rounded-icon />Referral activity is tracked for you
                    </li>
                </ul>
            </div>

            <f7-link :href="addReferralUrl" class="mui-button w-100 accent">
                <send-icon />
                Share your referral page
            </f7-link>

            <h2 class="preview-title">Here is how page look like</h2>
            <div class="preview">
                <iframe v-if="previewUrl" :src="previewUrl" frameborder="0" @load="iframeLoaded()"></iframe>
                <loader v-if="!previewReady" class="preview-loader" :show="true" :global="false" />
            </div>

            <f7-link v-if="previewUrl" external :href="previewUrl" target="_blank" class="mui-button w-100 accent-fg">
                <external-link-icon />
                Preview my referral page</f7-link>
        </div>
        <loader v-if="loading" :show="true" />
    </f7-page>

</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { PAGES } from '../../shared/routes.constants'
import CheckRoundedIcon from '@components/icons/check-rounded.icon.vue'
import SendIcon from '@components/icons/send.icon.vue'
import ExternalLinkIcon from '../../components/icons/external-link.icon.vue'
import Loader from '@components/loader.vue'
export default {
  name: 'what-friends-see',
  components: {
    'check-rounded-icon': CheckRoundedIcon,
    SendIcon,
    ExternalLinkIcon,
    Loader
  },
  computed: {
    ...mapState({
      salesReferralUrl: (state) => state.common.salesSite ? `${state.common.salesSite}/referrals` : null
    }),
    ...mapGetters({
      sharedLinkData: 'recommendFriend/sharedLinkData'
    }),
    previewUrl () {
      return this.sharedLinkData ? this.sharedLinkData.link : null
    }
  },
  mounted: async function () {
    if (!this.sharedLinkData.link) {
      this.loading = true
      await this.getSharedLink()
      this.loading = false
    }
  },
  methods: {
    ...mapActions({
      getSharedLink: 'recommendFriend/getShareLink'
    }),
    goBack () {
      this.$router.load({ url: `/${PAGES.RecommendAFriend}` })
    },
    iframeLoaded () {
      this.previewReady = true
    }
  },
  data () {
    return {
      loading: false,
      previewReady: false,
      addReferralUrl: `${PAGES.RecommendAFriendReferral}`
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
    padding-inline: 18px;
    padding-block: 8px 16px;
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    row-gap: 16px;

    >.title {
        font-weight: 600;
        font-size: 28px;
    }

    .preview-title {
        font-size: 16px;
        font-weight: 600;
    }
}

.options {
    display: grid;
    align-items: start;
    gap: 6px;

    li {
        display: flex;
        align-items: center;
        gap: 1ch;
    }

    svg {
        color: #1CB995;
    }
}

.preview {
    width: 100%;
    max-width: 340px;
    aspect-ratio: 9 / 16;
    margin-inline: auto;

    position: relative;
    overflow: hidden;

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(transparent 44%, #fff 95%);
    }

    iframe {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        pointer-events: none;
        border-radius: 28px;
        border: 10px solid #011A4B;

    }

    .preview-loader {
        position: absolute;
        inset: 0;
        display: grid;
        place-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// what-friends-see.vue?3b795079